var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 167,
    viewBox: "0 0 79 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9533 8.19509C38.9533 8.19509 42.3133 16.2951 52.4133 17.8251C52.4133 17.8251 48.2833 43.8251 34.5233 33.4251C20.7633 23.0251 28.4033 4.82509 38.9533 8.19509V8.19509Z",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5633 39.6351C34.5633 39.6351 23.6633 37.8651 22.8933 29.9151C22.1333 21.9651 23.3533 1.62509 39.4133 1.01509C55.4733 0.405091 58.0733 18.4451 57.1533 26.5551C56.2333 34.6551 47.2633 38.9451 45.4733 39.4051",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7733 33.7051C45.7733 33.7051 44.2133 42.1751 48.2033 43.3351C52.1933 44.4951 59.8333 43.4351 67 56.5C71.79 68.61 74.8833 74.0851 74.8833 74.0851L59.8333 75.1351C59.8333 75.1351 59 78.5 61 88C63 97.5 65.1933 115.265 65.1933 115.265C65.1933 115.265 42.5 126.5 13.8833 115.685C13.8833 115.685 16.925 100.5 18.8316 91C20.7381 81.5 20.3311 78.1208 19.3533 75.5551L3.39333 73.8651C3.39333 73.8651 12.41 48.95 20.5 46C28.6 43.05 30.4233 43.4351 30.4233 43.4351C30.4233 43.4351 35.2333 42.8651 34.4033 33.7351",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6733 43.5751C48.6733 43.5751 37.3233 50.5051 30.6033 43.5551",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8549 115C64.8549 115 66.5981 126.773 58 166",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2233 115.445C14.2233 115.445 12.5 127 21 165.5",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2933 165.515C37.2933 165.515 36.8733 140.445 39.6133 135.705C42.3533 130.965 42.0333 165.615 42.0333 165.615",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6633 74.2551C72.6633 74.2551 72.4833 90.8651 74.6133 96.8651C76.7433 102.865 76.4333 122.935 76.4333 122.935C76.4333 122.935 81.7233 140.155 72.3233 141.655C72.3233 141.655 69.6333 141.735 73.0333 138.025C76.4333 134.315 72.7933 130.045 72.7933 130.045L72.6333 136.605C72.6333 136.605 68.1333 133.845 69.5533 129.815C70.9733 125.785 74.1333 122.315 71.5233 115.915C68.9133 109.515 64.5733 102.485 64.1733 96.7151C63.7833 90.9451 62.6733 75.0251 62.6733 75.0251",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12332 74.1751C6.12332 74.1751 6.44332 90.5251 4.30332 96.5351C2.17332 102.535 2.48332 122.605 2.48332 122.605C2.48332 122.605 -2.80668 139.825 6.59332 141.325C6.59332 141.325 9.28332 141.405 5.88332 137.695C2.48332 133.985 6.12332 129.715 6.12332 129.715L6.28332 136.275C6.28332 136.275 10.7833 133.515 9.36332 129.485C7.94332 125.455 4.78332 121.985 7.39332 115.585C10.0033 109.185 14.3433 102.155 14.7433 96.3851C15.1433 90.6151 15.8533 75.2951 15.8533 75.2951",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65 91.5C65 117.734 53.8071 146 40 146C26.1929 146 15 117.734 15 91.5C15 65.2665 26.1929 44 40 44C53.8071 44 65 65.2665 65 91.5Z",
    fill: "#7FBCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.df80976ecfd923db01465ccfc9658f5d.svg";
export { ForwardRef as ReactComponent };